import $ from "jquery";

export const SelectRole = function () {
	const $root = $(".select-role");
	if (!$root.length) {
		return false;
	}

	const $confirm = $root.find(".js-select-role-confirm");
	const $count = $root.find(".js-select-role-count");
	const maxGoals = parseInt($root.data("max-goals"), 10) || 3;
	const isLocked = String($root.data("locked")) === "1";

	const $goals = $root.find(".js-select-role-goal");

	const selectedCount = () => $goals.filter(":checked").length;

	const markSelected = ($checkbox) => {
		$checkbox
			.closest(".select-role__item")
			.toggleClass("is-selected", $checkbox.is(":checked"));
	};

	// Disabled inputs also stop their label from toggling them, so no extra goal can be picked.
	const lockRemaining = () => {
		if (isLocked) {
			$goals.each(function () {
				$(this)
					.prop("disabled", true)
					.closest(".select-role__item")
					.addClass("is-locked");
			});

			$confirm.prop("disabled", true);
			return;
		}

		const atLimit = selectedCount() >= maxGoals;

		$goals.each(function () {
			const $checkbox = $(this);
			const locked = atLimit && !$checkbox.is(":checked");

			$checkbox.prop("disabled", locked);
			$checkbox
				.closest(".select-role__item")
				.toggleClass("is-locked", locked);
		});
	};

	const syncConfirm = () => {
		const count = selectedCount();
		$count.text(`${count}/${maxGoals}`);
		$confirm.prop("disabled", count !== maxGoals);
	};

	const showLoading = () => {
		$root.addClass("is-loading");
		$confirm.prop("disabled", true);
	};

	const removeLoading = () => {
		$root.removeClass("is-loading");
		$confirm.prop("disabled", false);
	};

	$root.on("change", ".js-select-role-goal", function () {
		markSelected($(this));
		lockRemaining();
		syncConfirm();
	});

	lockRemaining();
	syncConfirm();

	const $popup = $root.find(".js-select-role-popup");
	const $popupTitle = $root.find(".js-select-role-popup-title");
	const $popupText = $root.find(".js-select-role-popup-text");

	const openPopup = (title, text) => {
		$popupTitle.text(title);
		$popupText.html(text);
		$popup.removeAttr("hidden").addClass("is-active");
		$("body").addClass("popup-open");
	};

	const closePopup = () => {
		$popup.attr("hidden", true).removeClass("is-active");
		$("body").removeClass("popup-open");
	};

	$root.on("click", ".js-select-role-info", function (event) {
		event.preventDefault();
		event.stopPropagation();

		const $button = $(this);
		openPopup($button.attr("data-title") || "", $button.attr("data-text") || "");
	});

	$root.on("click", ".js-select-role-popup-close", function (event) {
		event.preventDefault();
		closePopup();
	});

	$popup.on("click", function (event) {
		if ($(event.target).closest(".select-role__popup-card").length) {
			return;
		}

		closePopup();
	});

	$(document).on("keydown.selectRolePopup", function (event) {
		if (event.key === "Escape" && $popup.hasClass("is-active")) {
			closePopup();
		}
	});

	if (isLocked) {
		return;
	}

	$confirm.on("click", function () {
		if (
			$confirm.prop("disabled") ||
			$root.hasClass("is-loading") ||
			selectedCount() !== maxGoals
		) {
			return;
		}

		showLoading();

		const learningGoals = $goals.filter(":checked").map(function () {
			return $(this).val();
		}).get();

		$.ajax({
			url: window.CFG.ajaxUrl,
			type: "POST",
			data: {
				action: "select-learning-goals",
				nonce: window.CFG.nonce,
				learning_goals: learningGoals,
			},
			success: function (response) {
				if (!response.success) {
					console.error(response.data.message || "Failed to select learning goals");
					alert(response.data.message || "Failed to select learning goals");
					return;
				}
				window.location.href = response.data.redirect;
			},
			error: function (error) {
				console.error(error);
				alert("An error occurred while selecting your learning goals. Please try again.");
			},
			complete: function () {
				removeLoading();
			},
		});
	});
};
